function Publishing_rule_form_element(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    checkboxMaster: '.js-checkbox-master',
	    containerDates: '.js-container-dates'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$containerDates = this.$element.find(this.selectors.containerDates);
	    this.$checkboxMaster = this.$element.find(this.selectors.checkboxMaster);

	    if (this.$containerDates.length) {

		    this.$checkboxMaster.on('i4:change', this.$onChangeCheckbox.bind(this));

			this.$formParent.on(this.triggers.afterLoaded, (function() {
				this.updateView();
			}).bind(this));
		}
    };

    this.$onChangeCheckbox = function() {
		this.updateView();
    };

    this.updateView = function() {
	    if (this.$checkboxMaster.is(':checked')) {
		    this.$containerDates.show();
	    } else {
		    this.$containerDates.hide();
	    }
    };
}
